<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 mb-3">
        <h5 class="card-title">Was möchten Sie vermarkten?</h5>
      </div>
    </div>
    <div class="row align-items-center mt-3">
      <div class="col-12 col-lg-6 font-bold">
        Welche Art Lokal betreiben Sie in erster Linie?
      </div>
      <div class="col-12 col-lg-6">
        <Field as="select" v-model="surveyStore.data.lokal_typ" id="lokal_typ" name="lokal_typ"
               class="form-select" :class="{'is-invalid': errors.lokal_typ}">
          <option value="">--- Bitte wählen Sie einen Typ ---</option>
          <template v-for="option in surveyStore.currentConfig.currentStep.lokal_typ.selectOptions" :key="option.key">
            <option :value="option.key">{{ option.label }}</option>
          </template>
        </Field>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "@/stores/survey";
import {Field} from 'vee-validate';

export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {}
  },
  props: {
    errors: Object,
  },
  methods: {},

}
</script>
